import SearchFlightsForm from "./form/SearchFlightsForm";
import SearchFlightsResultsButtons from "./results/SearchFlightsResultsButtons";
import SearchFlightsResults from "./results/SearchFlightsResults";
import React from "react";
import {useAppSelector} from "../../app/hooks";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import FormTopTabs from "./FormTopTabs";
import {useSelector} from "react-redux";
import {selectConfig} from "../config/ConfigSlice";
import SearchDestinationsResults from "./results/SearchDestinationsResults";

function SearchFlights({layout}) {
  const {components} = useSelector(selectConfig);
  const formDisabled = useAppSelector(
    (state) => state.searchFlights.form.disabled
  );

  const hasResults = useAppSelector(
    (state) => state.searchFlights.results.hasResults
  );

  const display = useAppSelector((state) => state.searchFlights.display);

  const hasDestinationsResults = useAppSelector((state) => state.searchFlights.destinationsResults.hasResults)

  if (layout === "vertical") {
    return (
      <>
        {components.FormTopTabs.length > 0 && <FormTopTabs/>}
        <SearchFlightsForm/>
        <ResultsLoading/>
        {formDisabled && (
          <div id="search-results-panel" className="block is-flex-grow-2">
            {hasDestinationsResults && display === "destinations" && (
              <SearchDestinationsResults/>
            )}
            {hasResults && display === "flights" && (
              <div className="is-flex is-flex-direction-column">
                <SearchFlightsResultsButtons/>
                <SearchFlightsResults layout={layout}/>
              </div>
            )}
            <NoResultsNotification/>
          </div>
        )}
      </>
    );
  } else {
    return (
      <div className="columns mx-1">
        <div className="column">
          {components.FormTopTabs.length > 0 && <FormTopTabs/>}
          <SearchFlightsForm/>
          <ResultsLoading/>
        </div>
        {formDisabled && hasDestinationsResults && display === "destinations" && (
          <SearchDestinationsResults/>
        )}
        {formDisabled && hasResults && display === "flights" && (
          <div className="column is-two-thirds">
            <div className="block m-2">
              <SearchFlightsResultsButtons/>
              <div className="search-results-horizontal">
                <SearchFlightsResults layout={layout}/>
              </div>
            </div>
          </div>
        )}
        <NoResultsNotification/>
      </div>
    );
  }
}

function ResultsLoading() {
  const loading = useAppSelector(
    (state) => state.searchFlights.results.loading
  );
  const destinationsLoading = useAppSelector((state) => state.searchFlights.destinationsResults.loading)
  const direction = useAppSelector(
    (state) => state.searchFlights.results.direction
  );
  const type = useAppSelector((state) => state.searchFlights.results.type);

  if ((loading && direction === "" && type === "") || destinationsLoading) {
    return <progress className="progress mt-2"/>;
  } else {
    return null;
  }
}

function NoResultsNotification() {
  const {t} = useTranslation();

  const loading = useAppSelector(
    (state) => state.searchFlights.results.loading
  );
  const destinationsLoading = useAppSelector((state) => state.searchFlights.destinationsResults.loading);
  const formDisabled = useAppSelector(
    (state) => state.searchFlights.form.disabled
  );
  const hasResults = useAppSelector(
    (state) => state.searchFlights.results.hasResults
  );
  const hasDestinationsResults = useAppSelector((state) => state.searchFlights.destinationsResults.hasResults);
  const display = useAppSelector((state) => state.searchFlights.display);
  const nonStop = useAppSelector((state) => state.searchFlights.form.nonStopFlights);

  if (formDisabled && (
    (display === "destinations" && !hasDestinationsResults && !destinationsLoading) ||
    (display === "flights" && !hasResults && !loading)
  )) {
    return (
      <div className="notification columns is-warning is-vcentered m-1">
        <div className="column is-narrow is-hidden-mobile">
          <FontAwesomeIcon icon={faExclamationTriangle}/>
        </div>
        <div className="column">
          <p className="has-text-weight-bold">{t("LABEL_NO_FLIGHTS_FOUND")}</p>
          <p>{t(nonStop ? "HEADER_NO_DIRECT_FLIGHTS" : "LABEL_NO_FLIGHTS_FOUND_DETAIL")}</p>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default SearchFlights;
